import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import comingSoon from "../../../../images/coming_soon.svg";

/**
 * ActionItems - Action items view for the active session.
 */
const ActionItems = () => {
  return (
    <>
      <Row height="48px"/>
      <Row spacing="none">
        <Column width="13px"/>
        <img src={comingSoon} alt="Coming soon" />
      </Row>
      <Row spacing="none">
        <Column width="67px"/>
        <Column alignmentHorizontal="start" spacing="none" width="238px">
          <Row height="24px"/>
          <Text type="h50" alignment="center">Coming soon</Text>
        </Column>
      </Row>
    </>
  );
};

export default ActionItems;
